import qs from 'query-string';
import Cookie from 'universal-cookie';

export const ACCESS_TOKEN = 'access_token';

const cookie = new Cookie();

/**
 * 抽取AccessToken
 * @param {String} hash   hash值
 */
export function extractAccessTokenFromHash(hash) {
  if (hash) {
    const ai = hash.indexOf(ACCESS_TOKEN);
    if (ai !== -1) {
      const accessTokenReg = /#?access_token=[0-9a-zA-Z-]*/g; // /#access_token
      const result = hash.match(accessTokenReg);
      if (!result) {
        return null;
      }
      const centerReg = result[0];
      return centerReg.split('=')[1];
    }
  } 
  return null;
}

/**
 * 存储token
 */
export function setAccessToken(token) {
  cookie.set(ACCESS_TOKEN, token, {
    path: '/',
  });
}

/**
 * 移除token
 */
export function removeAccessToken() {
  cookie.remove(ACCESS_TOKEN, { path: '/' });
}

/**
 * 获取token
 */
export function getAccessToken() {
  return cookie.get(ACCESS_TOKEN, { path: '/' })
}

// 从URL中获取token，包括#access_token和&token
export function getAccessTokenFromUrl() {
  const hashToken = extractAccessTokenFromHash(window.location.hash); // #access_token=token
  const { query } = qs.parseUrl(window.location.href); // &token=token
  const queryToken = query?.token;
  return hashToken || queryToken;
}

/**
 * 移除hash值
 */
export function removeHash() {
  let scrollV;
  let scrollH;
  const loc = window.location;
  if ('replaceState' in window.history) {
    window.history.replaceState('', document.title, `${loc.pathname}${loc.search}`);
  } else {
    scrollV = document.body.scrollTop;
    scrollH = document.body.scrollLeft;
    loc.hash = '';
    document.body.scrollTop = scrollV;
    document.body.scrollLeft = scrollH;
  }
}
